import React from 'react'
import { useStyletron } from 'styletron-react'
import { popMenu__dividerStyles } from './Styles'

const PopMenuDivider = () => {
  const [css] = useStyletron()
  return <span className={css(popMenu__dividerStyles)} />
}
export default PopMenuDivider
